import { Box } from '@mui/material';
import React from 'react';
import { ResultList } from './ResultList';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(() => ({
  root: {
    maxHeight: 'calc(100% - 32px)',
    overflowY: 'auto',
  },
  content: { maxWidth: '750px', marginLeft: 'auto', marginRight: 'auto' },
}));

export const groupByAction = (results) => {
  return (results || []).reduce((acc, v) => {
    v.actions.forEach((action) => {
      acc[action] = [...(acc[action] || []), { ...v, actions: [], action }];
    });
    return acc;
  }, {});
};

export const ResultListGroups = ({ rows, onActionClick }) => {
  const classes = useStyles();
  const rowsGroupedByAction = groupByAction(rows);

  return (
    <Box className={classes.root} data-testid="gs-results">
      <Box className={classes.content}>
        {Object.keys(rowsGroupedByAction).map((action) => {
          const rows = rowsGroupedByAction[action];
          return (
            <ResultList key={action} rows={rows} action={action} onActionClick={onActionClick} />
          );
        })}
      </Box>
    </Box>
  );
};
